module.exports = __webpack_public_path__ + "img/outlook.10ecf700.svg";